import React, { memo } from 'react'
import { Divider, Grid } from '@mui/material'
import { Trans } from 'react-i18next'

import {
  formatEth,
  formatEthCurrency,
  formatPts
} from '../../util/numbers.helpers'
import { formatTicks } from '../../util/string.helpers'
import DisplayStats from './DisplayStats'
import { ENABLE_SALE_RESULTS, SALE_PRICING } from '../../constants/app'
import SubHead from '../shared/text/SubHead'
import ReferFriends from './ReferFriends'
import LabelValue from '../shared/text/LabelValue'

const SaleDetails = ({ t, mainProfile, saleEnded, address }) => {
  const {
    nftCount,
    points,
    userDeposit,
    resultUserDeposit,
    preSaleDepositPrice,
    publicSaleDepositPrice,
    preRaffleDeposited,
    publicRaffleDeposited
  } = mainProfile
  const userDepositValue =
    saleEnded && ENABLE_SALE_RESULTS ? resultUserDeposit : userDeposit
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <DisplayStats
          data={[
            {
              label: t('home.pre-sale-raffle-tickets'),
              subDesc: (
                <>
                  <LabelValue
                    label={t('home.price')}
                    value={formatEth(preSaleDepositPrice)}
                  />
                  <LabelValue
                    label={t('home.bought')}
                    value={formatTicks(preRaffleDeposited)}
                    hint={
                      <SubHead
                        t={t}
                        value={t('home.worth-value', {
                          value: formatTicks(
                            SALE_PRICING.PRE_SALE_QBX_VALUE * preRaffleDeposited
                          )
                        })}
                        sx={{ fontSize: 12 }}
                      />
                    }
                    sx={{ mb: 0.5 }}
                  />
                </>
              ),
              desc: `${formatTicks(nftCount)} ${t('home.allocations-from-nfts')}`,
              descHelpText: t('home.pre-sale-help')
            },
            {
              label: t('home.public-sale-raffle-tickets'),
              subDesc: (
                <>
                  <LabelValue
                    label={t('home.price')}
                    value={formatEth(publicSaleDepositPrice)}
                  />
                  <LabelValue
                    label={t('home.bought')}
                    value={formatTicks(publicRaffleDeposited)}
                    hint={
                      <SubHead
                        t={t}
                        value={t('home.worth-value', {
                          value: formatTicks(
                            SALE_PRICING.PUBLIC_SALE_QBX_VALUE *
                              publicRaffleDeposited
                          )
                        })}
                        sx={{ fontSize: 12 }}
                      />
                    }
                    sx={{ mb: 0.5 }}
                  />
                </>
              )
            }
          ]}
          gridSize={6}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ mb: { xs: 2, md: 3 } }} />
        <DisplayStats
          data={[
            {
              label: t('home.your-deposit'),
              value: formatEthCurrency(userDepositValue),
              hoverText: formatEthCurrency(userDepositValue, 6)
            },
            {
              label: t('home.deposit-points-earned'),
              value: formatPts(points),
              helpText: t('home.deposit-points-help-text'),
              desc: !(saleEnded && ENABLE_SALE_RESULTS) && (
                <Trans i18nKey='home.it-takes-time-refresh'></Trans>
              )
            }
          ]}
          gridSize={6}
          descStyles={{
            fontWeight: 900,
            sx: {
              fontSize: '2.625rem'
            }
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider sx={{ mb: { xs: 2, md: 3 } }} />
        <ReferFriends
          t={t}
          address={address}
          mainProfile={mainProfile}
          saleEnded={saleEnded}
        />
      </Grid>
    </Grid>
  )
}

export default memo(SaleDetails)
